"use client";

import { useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";

export const ENABLE_PAGE_TRANSITIONS = true;

const PageTransition = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();
  const previousPathname = useRef(pathname);
  const [transitionKey, setTransitionKey] = useState(0);

  useEffect(() => {
    if (!ENABLE_PAGE_TRANSITIONS || previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    setTransitionKey((key) => key + 1);
  }, [pathname]);

  if (!ENABLE_PAGE_TRANSITIONS) return <>{children}</>;

  return <div key={transitionKey} className={transitionKey ? "page-transition" : undefined}>{children}</div>;
};

export default PageTransition;
